export default __webpack_public_path__ + "static/media/calculator.74e19255.png";